import { api } from "./apiBaseQuery";

export const reportsServices: any = api.injectEndpoints({
  endpoints: (builder) => ({
    GetAcademicRecord: builder.mutation({
      query: () => {
        return {
          url: `Reportes/Reporte/VidaAcademica`,
          method: "GET",
          responseHandler: "text",
        };
      },
    }),
    getScholarshipHistory: builder.mutation({
      query: () => {
        return {
          url: `Reportes/PruebaReporte`,
          method: "GET",
          responseHandler: "text",
        };
      },
    }),
    GetCurrentGrades: builder.mutation({
      query: () => {
        return {
          url: `Reportes/PruebaReporte`,
          method: "GET",
          responseHandler: "text",
        };
      },
    }),
    getAccountStatement: builder.mutation({
      query: () => {
        return {
          url: `Reportes/Reporte/EstadoCuentaEstudiante`,
          method: "GET",
          responseHandler: "text",
        };
      },
    }),
  }),
});

export const {
  useGetAcademicRecordMutation,
  useGetCurrentGradesMutation,
  useGetScholarshipHistoryMutation,
  useGetAccountStatementMutation,
} = reportsServices;
